import { APIResultCount } from '../../../constant'
import { useGetCustomerSuppliers } from '../../../api/supplier'
import { GlobalDocumentContainer } from './GlobalDocumentContainer'
import { CenteredSpinner } from '../../../components/Spinner'
import { useParams } from 'react-router-dom'
import { GlobalDocumentType } from 'src/enums'

export const GlobalDocumentCustomerContainer: React.FC = () => {
  const { id: customerId } = useParams()
  const { data: customerSuppliers, isLoading: customerSuppliersLoading } = useGetCustomerSuppliers(
    customerId as EntityId,
    0,
    APIResultCount.Max,
    true,
    true,
  )
  if (customerSuppliersLoading) {
    return <CenteredSpinner />
  }
  return (
    <GlobalDocumentContainer customerSuppliers={customerSuppliers} globalDocumentType={GlobalDocumentType.Equipment} />
  )
}
